import React, { useRef, useState, useEffect } from 'react';
import { ListView } from '@tencent/ptp-fe-common';
import { Dialog, message } from '@tencent/spaui';
import getTableConfig from './config/getTableConfig.js';
import getFilterConfig from './config/getFilterConfig';
import actions from '../../api/index.js';
import { useTypedSelector, useAppDispatch } from 'store/index';
import MultiUpload from 'pages/regist/components/MultiUpload';
import dayjs from 'dayjs';
import { getCsIndustryTree } from 'store/manager';

const options = ({ payloads, customFunctions }) => {
  const { csIndustryTree, csIndustryTreeHash, appTypeOptions } = payloads;
  // const { downloadData, setContractDialog, setUpdateFileDialog, changeJoinState, chooseState } = customFunctions;
  const { setContractDialog, setUpdateFileDialog, changeJoinState, chooseState } = customFunctions;
  return {
    fetchConfig: {
      action: (params) => {
        const {
          page,
          pageSize,
          type, // 需求类型
          target, // 需求目标
          tenderStatus, // 参与状态
          companyIndustry, // 所在行业
          yusuan,
          // lowBudget,
          // highBudget,
        } = params;
        let yusuanArr = [];
        if (!yusuan || yusuan.length === 0) {
          yusuanArr = null;
        } else {
          yusuan.forEach((item) => {
            const [low, heigh] = item.split('-');
            yusuanArr.push([+low, +heigh]);
          });
        }

        const param = {
          page,
          page_size: pageSize,
          type_list: type,
          target_list: target,
          tender_status_list: tenderStatus,
          company_industry_list: companyIndustry,
          budget: yusuanArr,
        };
        return actions.getOrderSquareList(param);
      },
      $onRequest(params) {
        return {
          ...params,
          // propsData: listData,
        };
      },
      $onResponse(res) {
        const { page_info: pageInfo = {}, list = [] } = res;
        return {
          list,
          page_info: {
            total_number: pageInfo.total_number,
          },
        };
      },
    },
    // toolbarConfig: getToolbarConfig({
    //   downloadData,
    // }),
    filterConfig: getFilterConfig({
      csIndustryTree,
      appTypeOptions,
    }),
    tableConfig: getTableConfig({
      csIndustryTreeHash,
      setContractDialog,
      setUpdateFileDialog,
      changeJoinState,
      chooseState,
    }),
  };
};

// eslint-disable-next-line react/display-name
export default () => {
  const listRef = useRef(null);
  const dispatch = useAppDispatch();
  const [contractDialog, setContractDialog] = useState({
    show: false,
    list: [],
    data: {},
  });
  const [updateFile, setUpdateFileDialog] = useState({
    show: false,
    list: [],
    data: {},
  });
  const {
    manager: { appTypeOptions, csIndustryTree, csIndustryTreeHash },
  } = useTypedSelector((state) => state);

  useEffect(() => {
    dispatch(getCsIndustryTree());
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  const downloadData = () => {
    console.log('下载数据');
  };

  const handleContractClose = () => {
    setContractDialog({ show: false, list: [], data: {} });
  };

  const handleUpdateFileClose = () => {
    setUpdateFileDialog({ show: false, list: [], data: {} });
  };

  const handleContractSubbmit = () => {
    const { id } = contractDialog.data;
    const { list } = contractDialog;
    if (list.length === 0) {
      message.error('请上传合同');
      return;
    }
    if (!list.every((item) => item.status === 'success')) {
      message.error('请删除上传失败的文件');
      return;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const contract_paths = []; // 合同文件路径数组
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const contract_names = []; // 合同文件名字数组
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const contract_type = []; // 枚举值，合同上传类型：1用户上传文件 2在线文档
    list.forEach((item) => {
      contract_paths.push(item.fileId);
      contract_names.push(item.file_name);
      contract_type.push('1');
    });
    actions
      .uploadContract({
        demand_id: id,
        contract_paths,
        contract_names,
        contract_type,
      })
      .then(() => {
        message.success('保存成功');
        // reloadData();
        handleContractClose();
      });
  };

  const handleUpdateFileSubbmit = () => {
    const { id } = updateFile.data;
    const { list } = updateFile;
    if (list.length === 0) {
      message.error('请上传补充资料');
      return;
    }
    if (!list.every((item) => item.status === 'success')) {
      message.error('请删除上传失败的文件');
      return;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const material_paths = []; // 资料文件路径数组
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const material_names = []; // 资料文件名字数组
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const material_type = []; // 枚举值，合同上传类型：1用户上传文件 2在线文档

    list.forEach((item) => {
      material_paths.push(item.fileId);
      material_names.push(item.file_name);
      material_type.push('1');
    });
    actions
      .uploadUpdateFile({
        demand_id: id,
        material_paths,
        material_names,
        material_type,
      })
      .then(() => {
        message.success('保存成功');
        // reloadData();
        handleUpdateFileClose();
      });
  };

  const reloadData = () => {
    listRef.current?.loadList();
  };

  // 修改参与状态
  const changeJoinState = (data, bool) => {
    if (!!bool) {
      // 服务商投标已截止后不能参与
      if (data.tender_expect_deadline) {
        if (dayjs().isAfter(dayjs(data.tender_expect_deadline))) {
          message.error('服务商投标已截止');
          return;
        }
      }

      // 参与
      actions
        .join({
          id: data.id,
        })
        .then(() => {
          reloadData();
          message.success('参与成功');
        });
    } else {
      // 取消参与
      actions
        .unJoin({
          id: data.id,
        })
        .then(() => {
          reloadData();
          message.success('取消参与成功');
        });
    }
  };

  // 修改中标状态
  const chooseState = (data, bool) => {
    if (!!bool) {
      // 确认中标
      actions
        .choose({
          id: data.id,
        })
        .then(() => {
          reloadData();
          message.success('确认中标成功');
        });
    } else {
      // 取消确认中标
      actions
        .unChoose({
          id: data.id,
        })
        .then(() => {
          reloadData();
          message.success('取消确认中标成功');
        });
    }
  };

  return (
    <div className="page-form-group">
      <div className="form-group-header">
        <h4>商机管理</h4>
      </div>
      <div className="form-group-content" style={{ padding: 0 }}>
        <ListView
          className="crm-table-list"
          ref={listRef}
          options={options}
          payloads={{
            csIndustryTree,
            csIndustryTreeHash,
            appTypeOptions,
          }}
          customFunctions={{
            downloadData,
            setContractDialog,
            setUpdateFileDialog, // 上传资料
            changeJoinState, // 修改参与状态
            chooseState, // 修改中标状态
          }}
        />
      </div>
      <Dialog
        style={{ width: '500px' }}
        title="上传合同"
        show={contractDialog.show}
        onClose={handleContractClose}
        onSubmit={handleContractSubbmit}
        onCancel={handleContractClose}
      >
        <div style={{ padding: '0 0 16px 10px' }}>请上传合同</div>
        <MultiUpload
          data={contractDialog.list}
          max={5}
          onChange={(list) => {
            setContractDialog({
              ...contractDialog,
              list,
            });
            console.log('多选的list', list);
          }}
        />
      </Dialog>

      <Dialog
        style={{ width: '500px' }}
        title="上传资料"
        show={updateFile.show}
        onClose={handleUpdateFileClose}
        onSubmit={handleUpdateFileSubbmit}
        onCancel={handleUpdateFileClose}
      >
        <div style={{ padding: '0 0 16px 10px' }}>请上传资料</div>
        <MultiUpload
          data={updateFile.list}
          max={5}
          onChange={(list) => {
            setUpdateFileDialog({
              ...updateFile,
              list,
            });
            console.log('多选的list', list);
          }}
        />
      </Dialog>
    </div>
  );
};
